import { useCallback } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { CogIcon } from 'foundations-assets/icons/components/CogIcon';
import { Small } from 'foundations-components/transitional/components/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { PrettyPrintJson } from './PrettyPrintJson';
import { LoadingDotsIcon } from './LoadingDotsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function isEmptyInput(value) {
  if (value == null) return true;
  if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) {
    return true;
  }
  return false;
}
export function DefaultToolCall({
  pair
}) {
  const {
    input,
    output,
    pending
  } = pair;
  const isError = (output === null || output === void 0 ? void 0 : output.type) === 'TEXT' && output.isError;
  const isPending = !output && Boolean(pending);
  const unwrappedInput = input.input;
  const renderContent = useCallback(() => {
    return /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "400",
      paddingInline: "400",
      paddingBlockEnd: "400",
      children: [!isEmptyInput(unwrappedInput) && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Small, {
          weight: "demi",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "breezeEngineChatComponents.blocks.input"
          })
        }), /*#__PURE__*/_jsx(PrettyPrintJson, {
          data: unwrappedInput
        })]
      }), isPending && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Small, {
          weight: "demi",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "breezeEngineChatComponents.blocks.output"
          })
        }), /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          gap: "200",
          paddingInlineStart: "300",
          children: /*#__PURE__*/_jsx(LoadingDotsIcon, {})
        })]
      }), output && output.type === 'TEXT' && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Small, {
          weight: "demi",
          use: isError ? 'error' : undefined,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: isError ? 'breezeEngineChatComponents.blocks.error' : 'breezeEngineChatComponents.blocks.output'
          })
        }), /*#__PURE__*/_jsx(PrettyPrintJson, {
          data: output.content
        })]
      }), output && output.type === 'IMAGE' && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Small, {
          weight: "demi",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "breezeEngineChatComponents.blocks.output"
          })
        }), /*#__PURE__*/_jsx("img", {
          src: `data:${output.mimeType};base64,${output.base64Data}`,
          alt: output.filename || unescapedText('breezeEngineChatComponents.blocks.toolOutput'),
          style: {
            maxWidth: '100%'
          }
        })]
      })]
    });
  }, [unwrappedInput, output, isPending, isError]);
  return /*#__PURE__*/_jsx("div", {
    "data-block-type": "tool-call-group",
    "data-error": isError || undefined,
    "aria-busy": isPending || undefined,
    children: /*#__PURE__*/_jsx(AccordionItem, {
      size: "extra-small",
      flush: true,
      animate: true,
      removeContentPadding: true,
      renderContent: renderContent,
      title: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        gap: "200",
        children: [/*#__PURE__*/_jsx(CogIcon, {
          size: "300"
        }), /*#__PURE__*/_jsx("span", {
          children: input.name
        })]
      })
    })
  });
}